import Moment from 'moment';
import 'moment/locale/es';

Moment.updateLocale('es', {
	relativeTime: {
		future: 'en %s',
		past: 'hace %s',
		s: 'ahora',
		ss: 'ahora',
		m: '1 min',
		mm: '%d min',
		h: '1 hora',
		hh: '%d horas',
		d: '1 dia',
		dd: '%d dias',
		w:	'1 semana',
		ww:	'%d semanas',
		M: '1 mes',
		MM: '%d meses',
		y: '1 año',
		yy: '%d años',
	},
});

Moment.locale('es');

// Helper para formatear fecha manteniendo la hora local pero forzando formato ISO con zona horaria de Madrid
Moment.prototype.toMadridTime = function () {
	// Obtener la fecha/hora actual del objeto moment (en la zona horaria local)
	const year = this.year();
	const month = this.month();
	const date = this.date();
	const hour = this.hour();
	const minute = this.minute();
	const second = this.second();

	// Calcular si estamos en horario de verano europeo en Madrid
	let isDST = false;

	if (month > 2 && month < 9) {
		// Entre abril y septiembre siempre es horario de verano
		isDST = true;
	} else if (month === 2) {
		// Marzo: buscar último domingo (cambio a horario de verano)
		const lastSunday = 31 - ((5 * year / 4 + 4) % 7);
		isDST = date > lastSunday || (date === lastSunday && hour >= 2);
	} else if (month === 9) {
		// Octubre: buscar último domingo (cambio a horario de invierno)
		const lastSunday = 31 - ((5 * year / 4 + 1) % 7);
		isDST = date < lastSunday || (date === lastSunday && hour < 3);
	}

	// UTC+1 en invierno, UTC+2 en verano
	const offset = isDST ? 120 : 60;

	// Crear un nuevo momento con la misma fecha/hora pero con el offset de Madrid
	return Moment.utc([year, month, date, hour, minute, second]).utcOffset(offset, true);
};

export default Moment;
